import { z } from "zod/v4-mini";

import { apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { BaseApiDatasourceSpec } from "@/io/datasource/BaseApiDatasource.ts";
import {
  MedicalDevice,
  MedicalDeviceCreationDTO,
  MedicalDeviceDTO,
  medicalDeviceSchema,
} from "@/models/DeviceModel.ts";
import { PumpEventDTO } from "@/models/PumpEventModel.ts";
import { cz } from "@/utils/zodUtils.ts";

export class DeviceRepository {
  constructor(private readonly datasource: BaseApiDatasourceSpec = apiDataSource) {}

  getDevices = async () => this.datasource.get<MedicalDevice[]>(`/uploader/devices/`, z.array(medicalDeviceSchema));

  createDevice = async (device: MedicalDeviceCreationDTO) =>
    this.datasource.post<unknown>(`/uploader/devices/`, cz.ignore(), device);

  getDevicesByType = async (name: string) => {
    const devices = await this.getDevices();
    return devices.filter(device => device.deviceType.name === name);
  };

  updatePump = async (device: MedicalDeviceDTO) =>
    this.datasource.post<unknown>(`/uploader/pumps/`, cz.ignore(), device);

  bulkCreatePumpEvents = async (device: MedicalDeviceDTO, events: PumpEventDTO[]) =>
    this.datasource.post<unknown>(`/uploader/pumps/events/bulk_create/`, cz.ignore(), {
      device_sn: device.serial_number,
      device_name: device.device_type_name,
      events,
    });

  uploadRawData = async (device: MedicalDeviceDTO, rawData: string) =>
    this.datasource.post<unknown>(`/uploader/devices/raw_data/`, cz.ignore(), {
      device,
      raw_data: rawData,
    });
}
